"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailList = void 0;

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

var Detail = function Detail(_ref) {
  var _detail$title, _detail$description;

  var detail = _ref.detail;
  return detail ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
      bold: true,
      children: (_detail$title = detail === null || detail === void 0 ? void 0 : detail.title) !== null && _detail$title !== void 0 ? _detail$title : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
      children: (_detail$description = detail === null || detail === void 0 ? void 0 : detail.description) !== null && _detail$description !== void 0 ? _detail$description : ''
    })]
  }) : null;
};

var DetailList = function DetailList(_ref2) {
  var details = _ref2.details;

  if (!(details !== null && details !== void 0 && details.length)) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: details.map(function (detail, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Detail, {
        detail: detail
      }, index);
    })
  });
};

exports.DetailList = DetailList;
//# sourceMappingURL=detail-list.js.map